import { Link } from '@tiptap/extension-link';

/**
 * Tiptap Link mark extended with a `linkState` attribute that round-trips
 * `data-link-state` between the rendered DOM and the prosemirror schema.
 * Used by the documentation editor + reader so server-decorated broken /
 * pending links keep their state attribute when rendered, and CSS rules can
 * style them without any FE classification logic.
 *
 * The attribute is dropped on tiptap-markdown serialisation (markdown has no
 * way to express it), which is the correct behaviour — state is freshly
 * derived by the backend on each read.
 */
export const LinkWithState = Link.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      linkState: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-link-state'),
        renderHTML: (attributes) => {
          if (!attributes.linkState) return {};
          return { 'data-link-state': attributes.linkState };
        },
      },
    };
  },
});
